// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".heading2_5e1e {\n  margin: 0;\n  font-weight: normal;\n  font-size: 1.25rem;\n  line-height: 1.5;\n}", "",{"version":3,"sources":["/home/runner/work/telemetry/telemetry/ts/packages/frontend/src/component/common/Heading2.scss","Heading2.scss"],"names":[],"mappings":"AAEA;EACI,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;ACDJ","file":"Heading2.scss","sourcesContent":["@import \"@formant/ui/style/common\";\n\n.heading2 {\n    margin: 0;\n    font-weight: normal;\n    font-size: 1.25rem;\n    line-height: 1.5;\n}\n",".heading2 {\n  margin: 0;\n  font-weight: normal;\n  font-size: 1.25rem;\n  line-height: 1.5;\n}"]}]);
// Exports
exports.locals = {
	"heading2": "heading2_5e1e"
};
module.exports = exports;
